import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Bowls = () => {
  return (
    <SportsLayoutComp name={'Bowls'}/>
  )
}

export default Bowls